<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">
                <div id="sendinvites" class="amTealregular wrap">Send Invites Directly</div>
                <input type="text" class="inputbox" v-model="inviteemail">
                <div id="wrapper" class="wrap">
                <div id="send" class="btn bgTeal cpointer" @click="sendInvite">INVITE</div>
                </div>
            </div>
            <div id="rightcolumn" class="cols">
                <div id="betas" class="amTealregular wrap">Early SignUp Email List</div>
                <div id="fetch" class="wrap cpointer" @click="fetchNew">Fetch New</div>
                <div id="listof" class="wrap">
                    <div v-for="(invite, index) in invitees" v-bind:key="index">
                        <div id="holderofinvites">
                            <div id="namef" class="fullname">{{invite.fullname}}</div>
                            <div id="emailadd" class="emailAddress">{{invite.email}}</div>
                            <div id="send" class="btn bgTeal cpointer" v-if="!invite.invited" @click="sendbetaInvite(invite)">INVITE</div>
                            <div id="send" class="btn bgTeal cpointer" v-if="invite.invited">done</div>
                            <div id="ttpe" class="emailAddress wrap">{{invite.userType}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main';
import firebase from 'firebase/app';
import "firebase/functions";
import "firebase/auth";
export default {
    name: "betainvites",
    data(){
        return{
            inviteemail: null,
            invitees: [],
            userID: ""
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.userID = firebase.auth().currentUser.uid;
                db.collection("waitlist").where("user_Id", "==", this.userID).get().then(documents =>{
                   documents.forEach(document =>{
                    const signup = document.data()
                    signup.invited = false
                    this.invitees.push(signup)
                   })
               })
            }
        })
        
    },
    methods: {
        fetchNew(){
        this.userID = firebase.auth().currentUser.uid;
        const getbeta = firebase.functions().httpsCallable('betalist');
        getbeta({uid:this.userID}).then(function(result){  
           if (result){
            //    console.log("success")
               db.collection("beta").where("user_Id", "==", this.userID).get().then(documents =>{
                   documents.forEach(document =>{
                    const signup = document.data()
                    signup.invited = false
                    this.invitees.push(signup)
                   })
               })
           }
        }).catch(function(error){
            if (error == error){
                console.log('')
                // console.log('error', error)
            }
        })
        },
        sendbetaInvite(invite){
            invite.invited = true
            this.inviteemail = invite.email
                const newinvite = db.collection('invites').doc()
                let data = {
                emailinvited: this.inviteemail,
                invite_code: newinvite.id,
                invitedby: "artmuseo",
                serverTime: Date()
                }
                newinvite.set(data)
                this.inviteemail = null

                db.collection("beta").doc(invite.inviteID).delete()
        },
        sendInvite(){
            if (this.inviteemail !== null){
                const newinvite = db.collection('invites').doc()
                let data = {
                emailinvited: this.inviteemail,
                invite_code: newinvite.id,
                invitedby: "artmuseo",
                serverTime: Date()
                }
                newinvite.set(data)
                this.inviteemail = null
            } else {
                alert("There is no email listed")
                return
            }
        }
    }
}
</script>

<style scoped>
#mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
}

.btn {
    width: 50%;
    margin-left: 25%;
    height: auto;
    padding: 3%;
    float: left;
    clear: right;
    font-size: 1em;
    line-height: 1em;
    color: white;
    margin-bottom: 10px;
    border-radius: 2vmin;
}
.btn:hover {
    background-color: teal;
}

.inputbox {
   width: 50%;
   height: auto;
   min-height: 50px;
   max-height: 50px;
   border-width: 2px;
   border-color: #00a89d;
   background-color: whitesmoke;
   float: left;
   clear: right;
   border-style: hidden;
   border-radius: 1vmin;
   padding: 2%;
   margin-bottom: 10px;
   margin-left: 25%;
 }

.wrap {
    width: 100%;
    height: auto;
    margin-top: 2%;
    margin-bottom: 2%;
}

#holderofinvites {
    width: 80%;
    height: auto;
    padding: 3%;
    margin-left: 10%;
    background-color: #00a89d;
    border-radius: 1vmin;
    margin-bottom: 10px;
}

.fullname {
    width: 100%;
    height: auto;
    font-family: 'cocomatpro-bold';
    font-size: 1em;
    color: white;
}

.emailAddress {
    width: 100%;
    height: auto;
    font-family: 'cocomatpro-regular';
    font-size: .75em;
    color: white;
}
</style>